import React from 'react';
import { Typography, InputNumber, Button, Space } from 'antd';
import LlmModelPickerSection from '../models/LlmModelPickerSection';

const { Text } = Typography;

/**
 * Model / provider / window for query rewriting only (no strategy picker).
 */
export default function RagQueryRewriteAdvancedOptions({
    compact,
    maxMessages,
    onMaxMessagesChange,
    modelSource,
    onModelSourceChange,
    providerId,
    onProviderIdChange,
    model,
    onModelChange,
    cloudProviders,
    rewriteCloudModels,
    rewriteCloudModelsLoading,
    cloudModelSearch,
    onCloudModelSearchChange,
    ollamaFamilies,
    ollamaLoading,
    onRegisterOllama,
    navigate,
    disabled,
    onSaveAdvanced,
    saveLoading,
    /** Hide the primary save button (e.g. parent form has a single Save for the whole page). */
    hideSaveButton = false,
    /** When true, only the model / provider block is shown (e.g. widget follow-up LLM). */
    hideMaxMessages = false,
    sectionTitle = 'Rewriter options',
    modelStepLabel = 'Model for the rewrite step',
    picker,
}) {
    return (
        <div className={`rag-query-rewrite-advanced${compact ? ' rag-query-rewrite-advanced--compact' : ''}`}>
            <Text strong className="rag-query-rewrite-setting-subsection-title">
                {sectionTitle}
            </Text>
            {!hideMaxMessages && (
                <>
                    <Text type="secondary" className="rag-query-rewrite-setting-label">
                        How much of the chat to consider
                    </Text>
                    <Space align="center" wrap className="rag-query-rewrite-setting-row">
                        <Text>Max messages (user + assistant)</Text>
                        <InputNumber
                            min={4}
                            max={32}
                            value={maxMessages}
                            onChange={(v) => onMaxMessagesChange(v ?? 10)}
                            disabled={disabled}
                        />
                    </Space>
                </>
            )}
            <LlmModelPickerSection
                picker={picker}
                modelSource={modelSource}
                onModelSourceChange={onModelSourceChange}
                providerId={providerId}
                onProviderIdChange={onProviderIdChange}
                model={model}
                onModelChange={onModelChange}
                cloudProviders={cloudProviders}
                rewriteCloudModels={rewriteCloudModels}
                rewriteCloudModelsLoading={rewriteCloudModelsLoading}
                cloudModelSearch={cloudModelSearch}
                onCloudModelSearchChange={onCloudModelSearchChange}
                ollamaFamilies={ollamaFamilies}
                ollamaLoading={ollamaLoading}
                onRegisterOllama={onRegisterOllama}
                navigate={navigate}
                disabled={disabled}
                modelStepLabel={modelStepLabel}
            />
            {onSaveAdvanced && !hideSaveButton && (
                <Button
                    type="primary"
                    className="rag-query-rewrite-setting-save"
                    loading={saveLoading}
                    disabled={disabled}
                    onClick={onSaveAdvanced}
                >
                    Save rewriter options
                </Button>
            )}
        </div>
    );
}
